import React from 'react';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { HistoryStepperSC } from './history-stepper.styled';
import { ReactComponent as ChevronIcon } from '../../assets/svg/icon-chevron-left-white.svg';

interface HistoryStepperProps {
  historyDate: string | string[];
  historyCount: number;
  selectedPeriod?: string;
  onHistoryStepChange: (type: string) => void;
}

const HistoryStepper: React.FC<HistoryStepperProps> = ({
  historyDate,
  historyCount,
  selectedPeriod,
  onHistoryStepChange,
}) => {
  const renderDateFormatted = (period: string) => {
    switch (period) {
      case 'day':
        return (
          <>
            {moment(historyDate[0]).format('DD.MM.YYYY') === moment().format('DD.MM.YYYY') ? (
              <FormattedMessage id="life-id.today" />
            ) : (
              moment(historyDate[0]).format('DD.MM.YYYY')
            )}
          </>
        );
      case 'week':
        return `${
          moment(historyDate[0]).format('DD.MM.YYYY') +
          '-' +
          moment(historyDate[1]).format('DD.MM.YYYY')
        }`;
      case 'month':
        return `${moment(historyDate[0]).format('MMMM - YYYY')}`;
      case 'year':
        return `${moment(historyDate[0]).format('YYYY')}`;
    }
  };

  return (
    <HistoryStepperSC>
      <button className="back" onClick={() => onHistoryStepChange('back')}>
        <ChevronIcon />
      </button>
      <div className="center">{selectedPeriod && renderDateFormatted(selectedPeriod)}</div>
      <button
        className={historyCount === 0 ? 'next disabled' : 'next'}
        onClick={() => onHistoryStepChange('next')}
      >
        <ChevronIcon />
      </button>
    </HistoryStepperSC>
  );
};

export default HistoryStepper;
